import { createMockGatsbyImage } from '@ecomm/contentful-schemas'
import { createMockRichText } from '@ecomm/utils'

import type { FeatureSectionSchema } from './schema'

export const featureSectionMock = async (): Promise<FeatureSectionSchema> => ({
  __typename: 'ContentfulFeatureSection',
  body: {
    raw: await createMockRichText('## Title\nrich text example'),
    references: []
  },
  media: {
    mimeType: 'image',
    ...createMockGatsbyImage('/', 'example image'),
    file: { contentType: 'image', url: 'example image', fileName: '' }
  },
  type: 'Left Side Media'
})
